import * as yup from "yup";

export const alphaNumericPattern = /^[a-zA-Z0-9_ .-]*$/;
export const emailrgx =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;


export const addCourseSchema = yup.object({
  title: yup.string().required("Title is required"),
  startDate: yup.string().required("Start date is required"),
  endDate: yup.string().required("End date is required"),
});

export const editCourseSchema = yup.object({
  title: yup.string(),
  startDate: yup.string(),
  endDate: yup.string(),
});

export const registerSchema = yup.object({
  firstname: yup
    .string()
    .required("First name is required")
    .matches(/^[A-Za-z]+$/, "First name must contain only letters")
    .trim(),

  lastname: yup
    .string()
    .required("Last name is required")
    .matches(/^[A-Za-z]+$/, "Last name must contain only letters")
    .trim(),

  email: yup
    .string()
    .matches(emailrgx, "Please enter a valid email")
    .required("Email is required")
    .trim(),

  password: yup
    .string()
    .min(8, "Password must be at least 8 characters")
    .max(100, "Password cannot exceed 100 characters")
    .matches(
      /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*\d).{8,}$/,
      "Password must contain at least one uppercase letter, one special character, and one number"
    )
    .required("Password is required")
    .trim(),

  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Please confirm your password"),

  phone: yup
    .string()
    .matches(/^\d{11}$/, "Phone number must be exactly 11 digits")
    .required("Phone number is required")
    .trim(),

  group: yup.string().required("Group is required").trim(),

  category: yup.string().required("Category is required").trim(),

  isBaptised: yup.boolean().required("Select an option")

  // address: yup.string().required("Address is required"),
});


export const availableRegions = ["Randborg", "Sandton", "Midrand", "Soweto", " Limpopo"]; // Example regions 